import { render, staticRenderFns } from "./preview_recipients_persons.vue?vue&type=template&id=03566376&"
import script from "./preview_recipients_persons.vue?vue&type=script&lang=js&"
export * from "./preview_recipients_persons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports